export const CERTIFICATION_RESTAURANT_KITCHEN = "RESTAURANT_KITCHEN";
export const CERTIFICATION_C1_KITCHEN = "C1_KITCHEN";
export const CERTIFICATION_HACCP = "HACCP";
export const CERTIFICATION_GFSI = "GFSI";
